import { getShuntSet, setShuntSwitch, delShuntAccount } from '@/api/ChildInformation';

const state = {
  getShuntSet : {},
};

const mutations = {
  SET_DATA: (state, {key,data}) => {
    state[key] = data;
  },
};
const actions = {
  // 获取列表数据
  getShuntSet({ commit },data) { 
    return new Promise((resolve)=>{
      getShuntSet(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'getShuntSet',data:newData});
        } catch (error) {
          console.log(error)  
        }
        resolve( res.data )
      });
    })
  },

  // 开关
  setShuntSwitch({ commit },data) { 
    return new Promise((resolve)=>{
      setShuntSwitch(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'setShuntSwitch',data:newData});
        } catch (error) {
          console.log(error)  
        }
        resolve( res.data )
      });
    })
  },
  
  // 删除接收人
  delShuntAccount({ commit },data) { 
    return new Promise((resolve)=>{
      delShuntAccount(data).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'delShuntAccount',data:newData});
        } catch (error) {
          console.log(error)  
        }
        resolve( res.data )
      });
    })
  },
  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
